import React, { useEffect, useState } from 'react';
import { ReactComponent as IconNotFound } from 'images/not-true.svg';
import AssetValue from 'components/shared/AssetValue'
import SelectWithModalAssets from 'components/shared/SelectWithModal/SelectWithModalAssets';
import useGetIndexByQueryPaginatedInfinity from 'sdk/hooks/search/useGetIndexByQueryPaginatedInfinity';
import AssetRequestModal from './AssetRequestModal'
import styles from './AssetSelect.module.scss';

function AssetComponent({ data }: {
  data: any,
}) {
  const asset = data
  return (
    <div className={styles.assetComponent}>
      <div key={asset?.id} className={styles.catIcon}>
        {asset?.icon ? (<img src={asset?.icon} alt={asset?.name} />) : null}
      </div>
      <div className={styles.catNameCol}>
        <div className={styles.catCode}>
          {asset?.ticker}
        </div>
        <div className={styles.catName}>
          {asset?.name}
        </div>
      </div>
      <AssetValue asset={asset} className={styles.assetValue} />
    </div>
  )
}

function AssetSelect({
  value, onChange, disabled, placeholder, category, className,
}: {
  value: any,
  onChange: (v: any) => void,
  disabled?: boolean
  placeholder?: string
  category?: any
  className?: string
}) {
  const [search, setSearch] = useState<string>('')
  const [page, setPage] = useState(0);
  const [length, setLength] = useState(0);
  const [data, setData] = useState([]);
  const {
    mutate: getIndex,
    data: searchD,
    isLoading,
    isSuccess,
  } = useGetIndexByQueryPaginatedInfinity()

  useEffect(() => {
    setPage(0)
  }, [category?.name])

  useEffect(() => {
    if (search !== undefined) {
      getIndex({
        query: search, index: 'assets', category: category?.name, page,
      })
    }
  }, [search, page, category?.name])

  // @ts-ignore
  const assets = searchD?.data?.map((d) => d?.details)

  useEffect(() => {
    if (isSuccess) {
      // @ts-ignore
      setLength(searchD?.pagination?.length ?? 0)
      setData(assets)
    }
  }, [searchD, isSuccess])

  const [isAssetRequestVisible, setAssetRequestVisible] = useState(false)

  const handleNextPage = (p: number) => {
    setPage(p)
  }

  return (
    <>
      <SelectWithModalAssets
        className={className}
        options={(data || [])}
        title="Assets"
        onSelect={onChange}
        value={value}
        disabled={disabled}
        multiple
        isSearchable
        ItemComponent={AssetComponent}
        placeholder={placeholder}
        search={search}
        setSearch={setSearch}
        isLoading={isLoading}
        notFoundMessage={(
          <>
            <IconNotFound className={styles.msgIcon} />
            <span className={styles.msgTitle}>Oops</span>
            <span className={styles.msgText}>
              Unfortunately, this asset is not available, but you can request it
            </span>
          </>
        )}
        notFoundButton={{
          text: 'Request new a asset',
          onClick: (props: any) => {
            setAssetRequestVisible(true)
            props?.onClose()
          },
        }}
        hasNext={assets && assets.length < length}
        onNextPage={handleNextPage}
      />
      {isAssetRequestVisible ? (
        <AssetRequestModal onClose={() => setAssetRequestVisible(false)} />
      ) : null}
    </>
  )
}

export default AssetSelect
